// Stammdaten für die bestehenden Ticket- und Termin-Formulare – dieselben Abfragen wie die Ticketliste.

import { supabase } from '../../../../lib/supabase/client';
import type { Kategorie } from '../../tickets/types';

export interface FormularStammdaten {
  kategorien: Kategorie[];
  teamMembers: { id: string; full_name: string }[];
  teams: { id: string; name: string }[];
}

export async function ladeFormularStammdaten(): Promise<FormularStammdaten> {
  const [k, p, t] = await Promise.all([
    supabase.from('ticket_kategorien').select('*').eq('aktiv', true).order('sortierung'),
    supabase.from('profiles').select('id, full_name').in('role', ['admin', 'team', 'super admin']).eq('zuweisbar', true),
    supabase.from('teams').select('id, name').order('name'),
  ]);
  const fehler = k.error ?? p.error ?? t.error;
  if (fehler) throw new Error(fehler.message);
  return {
    kategorien: (k.data ?? []) as Kategorie[],
    teamMembers: ((p.data ?? []) as { id: string; full_name: string | null }[]).map(x => ({ id: x.id, full_name: x.full_name ?? '' })),
    teams: (t.data ?? []) as { id: string; name: string }[],
  };
}
